import { ReactNode } from "react";
import { MainLayout } from "../components/MainLayout";

export interface ConditionalMainLayoutProps {
  hideMainLayout: boolean;
  children: ReactNode;
  useDefaultTitle?: boolean;
}

export const ConditionalMainLayout = ({ hideMainLayout, children, useDefaultTitle }: ConditionalMainLayoutProps) => {
  if (hideMainLayout) {
    return <>{children}</>;
  }

  return <MainLayout useDefaultTitle={useDefaultTitle}>{children}</MainLayout>;
};
